import { PersonTypeEnum, SearchInsuredDetailsDto } from "api/actor";
import { ReferentialDto } from "api/referential";
import { BrokerDto, GetLeadBrokerListItemDto } from "api/broker";
import {
  BaseSearchResult,
  SearchFeatureFilter,
  SearchLeadBrokerResult,
  SearchPersonResult
} from "./types";

export type TransformFunction<T = SearchPersonResult> = (
  result: any,
  civilityReferential: ReferentialDto[]
) => T | null;

const transformPerson = (
  result: SearchInsuredDetailsDto,
  civilityReferential: ReferentialDto[]
): SearchPersonResult | null => {
  if (result.type === PersonTypeEnum.NaturalPerson && result.naturalPerson) {
    const civilityRef = civilityReferential.find(ref => ref.id === result.naturalPerson?.civilityId);

    return {
      id: result.id || result.naturalPerson.id || '',
      civility: civilityRef?.code,
      personType: PersonTypeEnum.NaturalPerson,
      name: `${result.naturalPerson.firstName} ${result.naturalPerson.lastName}`.trim(),
      phone: result.naturalPerson.phone,
      address: result.naturalPerson.address,
      data: result.naturalPerson
    };
  }

  if (result.type === PersonTypeEnum.LegalEntity && result.legalEntity) {
    return {
      id: result.id || result.legalEntity.id || '',
      personType: PersonTypeEnum.LegalEntity,
      name: result.legalEntity.companyName,
      registrationNumber: result.legalEntity.registrationNumber,
      phone: result.legalEntity.phone,
      address: result.legalEntity.address,
      data: result.legalEntity
    };
  }

  return null;
};

const transformBroker = (
  result: BrokerDto,
  _civilityReferential: ReferentialDto[]
): SearchPersonResult | null => {
  return {
    id: result.id,
    personType: PersonTypeEnum.LegalEntity,
    name: result.companyName,
    registrationNumber: result.registrationNumber,
    phone: result.phone,
    address: result.address,
    data: result
  };
};

const transformLeadBroker = (
  result: GetLeadBrokerListItemDto,
  _civilityReferential: ReferentialDto[]
): SearchLeadBrokerResult | null => {
  return {
    id: result.brokerId,
    personType: PersonTypeEnum.LegalEntity,
    name: result.label,
    email: result.email,
    phone: result.phone,
    branchCodes: result.branchCodes,
    pendingQuotesCount: result.pendingQuotesCount,
    data: result
  };
};

export const createTransformFunctions = <T extends BaseSearchResult = SearchPersonResult>(): Record<SearchFeatureFilter, TransformFunction<T>> => ({
  [SearchFeatureFilter.Default]: transformPerson as TransformFunction<T>,
  [SearchFeatureFilter.Broker]: transformBroker as TransformFunction<T>,
  [SearchFeatureFilter.LeadBroker]: transformLeadBroker as TransformFunction<T>,
});
